import {initializeApp} from "firebase/app";
import {getAuth, createUserWithEmailAndPassword} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const app = initializeApp({
    apiKey: "AIzaSyCe0Xcxf-YjAp6WhKNH10_TYsi0FydWtUQ",
    authDomain: "hentian-komuniti.firebaseapp.com",
    projectId: "hentian-komuniti",
    storageBucket: "hentian-komuniti.appspot.com",
    messagingSenderId: "30364908687",
    appId: "1:30364908687:web:3c4d1b43aa23b64e8d84fa"
  })
  
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;